module.exports = __webpack_public_path__ + "45cb176d41a1080fcc6c342bfaf2646c.jpg";